import {ChangeEvent, forwardRef, useImperativeHandle, useRef, MouseEvent, FC, ReactNode, HTMLAttributes, InputHTMLAttributes } from "react";
import { _ } from "../../utils/helpers";
import { ErrorInfo, Falsy, IconName } from "../../types";

interface InputTextProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
    value: string
    placeholder: string
    children?: ReactNode
    showErrorMessage?: boolean
    getError?: (value: string) => Falsy | ErrorInfo
}

interface InputTextHandle {
    showError: () => void
    hideError: () => void
}

export const InputText = forwardRef<InputTextHandle, InputTextProps>(({
    id, 
    value, 
    placeholder,
    getError,
    children,
    showErrorMessage = true,
    ...inputAttributes
}, ref) => {


    const inputRef = useRef<HTMLInputElement | null>(null)
    const errorRef = useRef<HTMLSpanElement | null>(null)
    const hasError = useRef<Falsy | ErrorInfo>(false)

    const showError = () => {
        if (!hasError.current) return
        inputRef.current!.classList.add('error')
        if (!showErrorMessage) return
        errorRef.current!.innerHTML = _(hasError.current.message)
        errorRef.current!.classList.add('visible')
    }
    const hideError = () => {
        errorRef.current!.classList.remove('visible')
        inputRef.current!.classList.remove('error')
    }

    useImperativeHandle(ref, () => ({
        showError,
        hideError
    }))

    const error = getError ? getError(value) : false
    
    return (
        <div id={`${id}-container`} className={`w-100 df fd-c aifs input-container ${error ? 'has-error' : ''}`}>
            <div className="input-slots w-100 df aifs">
                <input 
                    id={id} 
                    ref={inputRef} 
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    maxLength={50}
                    className={`input w-100 h-50p`}
                    aria-invalid="false"
                    aria-describedby={`${id}-error`}
                    {...inputAttributes}
                />
                {children}
            </div>
            <span 
                ref={errorRef}
                id={`${id}-error`} 
                className="input-error text s18-400 w-100"
            >
                {error ? _(error.message) : ''}
            </span>
        </div>
    )
})